export enum Routes {
  NotificationsRouter = '/notifications/*',
  DownloadsPage = 'downloads',
}
